import { CSSProperties, ReactElement } from 'react';
import { Container, Loader } from './styles';

interface LoaderRingProps {
  size?: 'small';
  style?: CSSProperties;
}

export const LoaderRing = ({ size, style }: LoaderRingProps): ReactElement => (
  <Container style={style}>
    <Loader size={size}>
      <div />
      <div />
      <div />
      <div />
    </Loader>
  </Container>
);
